export default {
  form: {
    shipping_company_name: {
      label: 'Empresa',
      placeholder: 'Introduzir nome da empresa',
    },
    shipping_phone_number: {
      label: 'Número de telefone',
      placeholder: 'Introduzir número de telefone',
    },
    shipping_salutation: {
      label: 'Tratamento',
      options: {
        mr: 'Sr.',
        mrs: 'Sra.',
      },
    },
    shipping_first_name: {
      label: 'Nome',
      placeholder: 'Introduzir nome',
    },
    shipping_last_name: {
      label: 'Apelido',
      placeholder: 'Introduzir apelido',
    },
  },
  buttons: {
    back: 'Voltar',
    next: 'Seguinte',
  },
};
